import { useEffect, useState } from "react";
import "./AppTimeOff.css";
import { CalendarPlus, Captions, UserPlus } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { AppPTOPolicies } from "./AppPTOPolicies";
import { useSelector } from "react-redux";
import { selectUser } from "../../../redux/features/appData";
import { apiGetPaidTimeOffPoliciesForWorkspace } from "../../../services/PaidTimeOffPolicyService";
import { PaidTimeOffPolicy } from "winslow-core";
import { AppPTORequests } from "./AppPTORequests";
import { AppPTOSchedule } from "./AppPTOSchedule";
import { AppCompanyHolidays } from "./AppCompanyHolidays";
import { AppPTOAccrualCalculator } from "./AppPTOAccrualCalculator";

const TABS = {
    REQUESTS: "time-off-requests",
    POLICIES: "time-off-policies",
    SCHEDULE: "time-off-schedule",
    HOLIDAYS: "time-off-holidays",
    ACCRUAL: "time-off-accrual"
}

type AppTimeOffProps = {
    
}

export const AppTimeOff = ({} : AppTimeOffProps) => {

    const storeUser = useSelector(selectUser)

    const navigate = useNavigate();
    
    const [tab, setTab] = useState<string>("time-off-requests");

    const [ptoPolicies, setPtoPolicies] = useState<PaidTimeOffPolicy[] | undefined>(undefined);

    useEffect(() => {
        if (!storeUser?.currentWorkspaceId) {
            return;

        }   
        // Fetch PTO policies from the server
        (async () => {
            const ptoPolicies = await apiGetPaidTimeOffPoliciesForWorkspace(storeUser.currentWorkspaceId || "");

            if (ptoPolicies) {
                setPtoPolicies(ptoPolicies);
            }

        })();
    }, []);

    return (
        <div className="app-time-off">
            <div className="app-time-off-tabs">
                <div 
                    className={tab === TABS.REQUESTS ? 
                        "app-time-off-tab-selected" : "app-time-off-tab"
                    }
                    onClick={() => setTab(TABS.REQUESTS)}
                >
                    Requests
                </div>
                <div 
                    className={tab === TABS.POLICIES ? 
                        "app-time-off-tab-selected" : "app-time-off-tab"
                    }
                    onClick={() => setTab(TABS.POLICIES)}
                >
                    Policies
                </div>
                <div 
                    className={tab === TABS.SCHEDULE ? 
                        "app-time-off-tab-selected" : "app-time-off-tab"
                    }
                    onClick={() => setTab(TABS.SCHEDULE)}
                >
                    Schedule
                </div>
                <div 
                    className={tab === TABS.HOLIDAYS ? 
                        "app-time-off-tab-selected" : "app-time-off-tab"
                    }
                    onClick={() => setTab(TABS.HOLIDAYS)}
                >
                    Holidays
                </div>
                <div 
                    className={tab === TABS.ACCRUAL ? 
                        "app-time-off-tab-selected" : "app-time-off-tab"
                    }
                    onClick={() => setTab(TABS.ACCRUAL)}
                >
                    Accrual Calculator
                </div>

                <div className="app-time-off-tab-actions">
                    {tab === TABS.POLICIES &&
                        <div
                            className="app-time-off-tab-action"
                            onClick={() => {
                                navigate("/app/time-off/policy-editor/new");
                            }}
                        >
                            <UserPlus size={16}/> Add Policy
                        </div>
                    }
                    {tab === TABS.REQUESTS &&
                        <div
                            className="app-time-off-tab-action"
                            onClick={() => {
                                navigate("/app/employee/time-off/request");
                            }}
                        >
                            <Captions size={16}/> Request Time Off
                        </div>
                    }
                    {tab === TABS.HOLIDAYS &&
                        <div
                            className="app-time-off-tab-action"
                            onClick={() => {
                                navigate("/app/time-off/holidays/new");
                            }}
                        >
                            <CalendarPlus size={16}/> Add a New Holiday
                        </div>
                    }
                    
                </div>
                
            </div>

            {TABS.REQUESTS === tab &&
                <AppPTORequests />
            }
            {TABS.POLICIES === tab &&
                <AppPTOPolicies ptoPolicies={ptoPolicies}/>
            }
            {TABS.SCHEDULE === tab &&
                <AppPTOSchedule />
            }
            {TABS.HOLIDAYS === tab &&
                <AppCompanyHolidays />
            }
            {TABS.ACCRUAL === tab &&
                <AppPTOAccrualCalculator />
            }
        </div>
    );
}